import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function pollTask(taskId, { interval = 2000, timeout = 120000 } = {}) {
  const start = Date.now();
  while (Date.now() - start < timeout) {
    const { data } = await api.get(`/tasks/${taskId}`);
    if (data.status === "done") return data.result;
    if (data.status === "error") throw new Error(data.error || "Task failed");
    await new Promise((r) => setTimeout(r, interval));
  }
  throw new Error("This is taking longer than expected — please try again.");
}

export default api;
